export default class FluentValidator {
  protected errorMessages: any = {}

  public getErrorMessage () {
    return this.errorMessages
  }
}
